<template>
    <v-container>
        <v-row>
            <v-col 
                :cols="(data.cols) ? data.cols.mobile : 10"
                :md="(data.cols) ? data.cols.tablet  : 8"
                :lg="(data.cols) ? data.cols.desktop  : 6"
                class="mx-auto" 
                data-aos="fade-right" 
                v-if="list.length"
                >
                <dialog-simple width="800" 
                btnBlock
                btnClass="rounded-pill"
                btnSize="large"
                :btnVariant="data.button.variant"
                :btnColor="data.button.color"
                :btnText="t('commons.aviability-modal.button')" 
                :title="t('commons.aviability-modal.title')">

                  <v-row>
                    <v-col cols="12">
                        <h2 class="text-h4 text-md-h3">{{ t('commons.aviability-modal.title') }}</h2>
                         <!-- Non mostrare la lista dei veicoli dati non sempre corretti -->
                        <!-- <h3>{{ t('commons.aviability-modal.sub_title') }}</h3> -->
                    </v-col>
                    <v-col cols="12">
                        <AvailabilityForm 
                            :button="t('commons.aviability-modal.button')" 
                            :list="list"></AvailabilityForm>
                    </v-col>
                  </v-row>

                </dialog-simple>
            </v-col>
        </v-row>
    </v-container>
</template>

<script setup>
import AvailabilityForm from './subComponents/AvailabilityForm.vue'
import { useLocale } from 'vuetify'
    const { t } = useLocale()
</script>

<script>
import {mapGetters} from "vuex";
export default {
    name: "ModalAvailabilityComponent",
    props:{
        data:{
            required: true,
            type: Object,
        }
    },
    computed: {
        ...mapGetters({
            loading: 'loading/loading',
            list: 'carsDrive/list',
            meta: 'carsDrive/meta',
            page: 'pages/single',
            adminPage: 'AdminPages/single',
        }),
    },
    data: () => ({
        title: null,
        current_page: null,
    }),
    mounted(){
        
        this.current_page = (this.page) ? this.page : this.adminPage;
        this.getList();

    },
    methods:{
        async getList(){
            let data = {
                page: 1,
                pageSize: 100,
                brandId: this.current_page.brand.drive_id,
                modelId: this.current_page.drive_model_id,
                typeId: this.current_page.type.drive_id,
                online: false,
                availableOnly: false,
            }
            await this.$store.dispatch('carsDrive/getList',data)
        }
    }
}
</script>